'use strict';

module.exports.post = require('../src/optimize');
module.exports.gsd = require('../src/gsd');



//////////////////
// WEBPACK FOOTER
// ./~/ml-gsd/src/index.js
// module id = 64
// module chunks = 0